import React, { memo, useEffect, useState } from "react"
import { Image as BaseImage, ImageProps, ImageRequireSource, ImageStyle, ImageURISource } from "react-native"
import { observer } from "mobx-react-lite"

const Image = memo(observer(function Image(props: ImageProps) {
  const { source: originalSource, ...rest } = props;

  const [ source, setSource ] = useState<ImageURISource|ImageURISource[]|ImageRequireSource>(originalSource)
  const [ uriBlob, setUriBlob ] = useState<string>(null)

  useEffect(() => {
    const source = originalSource as ImageURISource;
    if (!source || !source.headers) return;
    const { uri, headers, ...restSource } = originalSource as ImageURISource;
    fetch(uri, { headers })
      .then((response) => response.blob())
      .then(async (blob) => {
        const uriBlob = URL.createObjectURL(blob)
        await setSource({
          ...restSource,
          uri: uriBlob,
          headers
        })
        await setUriBlob(uriBlob)
      })
  }, [originalSource])

  useEffect(() => {
    return () => {
      uriBlob && URL.revokeObjectURL(uriBlob)
    }
  }, [uriBlob])

  if (
    source
    && typeof source !== "number"
    && typeof source !== "string"
    && "headers" in source
    && !uriBlob
  ) return null;

  return <BaseImage
    source={source}
    {...rest}
  />
}, { forwardRef: true }), (prevProps, nextProps) => (
  JSON.stringify(prevProps) === JSON.stringify(nextProps)
))

export { Image, ImageStyle }
